// extracted by mini-css-extract-plugin
export default {"addUserWrapper":"edit-group-dialog_addUserWrapper__pS8tW"};